import apiClient from './apiClient';
import {
  WheelDiscoveryPage,
  WheelDiscoveryDetail,
  ExpiryOption,
} from '../types/wheel';

export const wheelService = {
  // Discovery
  getExpiries: () =>
    apiClient.get<ExpiryOption[]>('/api/discover/wheel/expiries').then((r) => r.data),

  getTickerExpiries: (ticker: string) =>
    apiClient.get<ExpiryOption[]>(`/api/discover/wheel/${ticker}/expiries`).then((r) => r.data),

  getDiscoveryList: (page: number = 1, pageSize: number = 20, expiry?: string, safeOnly: boolean = true) =>
    apiClient.get<WheelDiscoveryPage>('/api/discover/wheel', { params: { page, page_size: pageSize, safe_only: safeOnly, ...(expiry && { expiry }) } }).then((r) => r.data),

  getAvgIv: (expiry?: string): Promise<Record<string, string>> =>
    apiClient.get<Record<string, string>>('/api/discover/wheel/avg-iv', { params: expiry ? { expiry } : {} }).then((r) => r.data).catch(() => ({} as Record<string, string>)),

  getDiscoveryDetail: (ticker: string, mode: 'recommended' | 'all' = 'recommended', optionType: 'P' | 'C' = 'P', skipLive: boolean = false, expiry?: string, includeStrike?: number) =>
    apiClient.get<WheelDiscoveryDetail>(`/api/discover/wheel/${ticker}`, { params: { mode, option_type: optionType, skip_live: skipLive, ...(expiry && { expiry }), ...(includeStrike && { include_strike: includeStrike }) } }).then((r) => r.data),

  refreshChain: (ticker: string, mode: 'recommended' | 'all' = 'recommended', optionType: 'P' | 'C' = 'P', expiry?: string, includeStrike?: number) =>
    apiClient.post<WheelDiscoveryDetail>(`/api/discover/wheel/${ticker}/refresh`, null, { params: { mode, option_type: optionType, ...(expiry && { expiry }), ...(includeStrike && { include_strike: includeStrike }) } }).then((r) => r.data),

  // Strategies
  listStrategies: () =>
    apiClient.get('/api/wheel').then((r) => r.data),

  getStrategy: (id: number) =>
    apiClient.get(`/api/wheel/${id}`).then((r) => r.data),

  createStrategy: (payload: { ticker: string; notes?: string }) =>
    apiClient.post('/api/wheel', payload).then((r) => r.data),

  deleteStrategy: (id: number) =>
    apiClient.delete(`/api/wheel/${id}`),

  updateState: (id: number, state: string, assignedStrike?: number) =>
    apiClient.patch(`/api/wheel/${id}/state`, { state, assigned_strike: assignedStrike }).then((r) => r.data),

  // Positions (trades linked to a strategy)
  addPosition: (strategyId: number, payload: Record<string, unknown>) =>
    apiClient.post(`/api/wheel/${strategyId}/positions`, payload).then((r) => r.data),

  closePosition: (strategyId: number, tradeId: number, payload: Record<string, unknown>) =>
    apiClient.post(`/api/wheel/${strategyId}/positions/${tradeId}/close`, payload).then((r) => r.data),
};
